export default {
  // 页面标题
  title: 'AhaCreator',
  newCampaign: 'New Campaign',

  // AI代理
  aiAgent: {
    placeholder: 'Interrupt me anytime with any question',
  },

  // 模态框标题
  modalTitles: {
    paymentDetails: 'Payment details',
  },

  // 按钮文本
  buttons: {
    saveDraft: 'Save draft',
    next: 'Next',
    update: 'Update',
    release: 'Release',
    signUpForMore: 'Sign up free for more',
    saveAndExit: 'Save & Exit',
  },

  // 帮助提示
  help: {
    whatHappensAfterPublish: 'What happens after you publish？',
    skipStepTooltip: 'Confident with your campaign information settings? You can skip this step and go straight to "Budget and results"',
  },

  // 关闭确认模态框
  closeModal: {
    title: 'Unsaved changes',
    description: 'You have unsaved changes, are you sure you want to exit?',
    notSaved: 'NOT SAVED',
  },

  // 消息提示
  messages: {
    rechargeFailed: 'Recharge failed',
    rechargeSuccessful: 'Recharge Successful! Your balance has been updated.',
  },

  // 错误消息
  errors: {
    getCampaignDetailFailed: 'Failed to get campaign details',
    bindOrgFailed: 'Failed to bind organization',
    networkError: 'Network error. Please refresh your page and try again.',
  },

  // 产品类型
  productType: {
    webApp: 'web app',
    mobileApp: 'mobile app',
    desktopApp: 'desktop app',
    browserExtension: 'browser extension',
    physicalProduct: 'physical product',
  },

  // 业务模式
  businessModel: {
    toBusiness: 'to business',
    toCustomer: 'to customer',
    b2b: 'B2B',
    b2c: 'B2C',
  },

  // 活动目标
  campaignObjective: {
    awareness: 'Awareness',
    websiteTraffic: 'Website Traffic',
    installs: 'Installs',
    leads: 'Leads',
    signUps: 'Sign-ups',
    sales: 'Sales',
  },

  // 活动目标子类型
  campaignObjectiveSubType: {
    subscription: 'Subscription',
    payAsYouGo: 'Pay-as-You-Go',
    oneTimePayment: 'One-time payment',
  },

  // 目标表单标签
  targetForm: {
    installs: {
      title: 'Your click-to-install conversion rate',
      desc: 'You can enter either your current conversion rate or your target conversion rate here to estimate your campaign\'s result.',
      tips: 'Industry benchmark: 60%-80%.',
      message: 'please enter click-to-install conversion rate',
    },
    signUps: {
      title: 'Your click-to-sign-up conversion rate',
      desc: 'You can enter either your current conversion rate or your target conversion rate here to estimate your campaign\'s result.',
      tips: 'Industry benchmark: 20%-50%.',
      message: 'please enter click-to-sign-up conversion rate',
    },
    leads: {
      title: 'Your click-to-lead conversion rate',
      desc: 'You can enter either your current conversion rate or your target conversion rate here to estimate your campaign\'s result.',
      tips: 'Industry benchmark: 1%-5%.',
      message: 'please enter click-to-lead conversion rate',
    },
  },

  // 目标选项
  targetOptions: {
    traffic: {
      title: 'Traffic',
      desc: 'Direct the right audience to your destinations, such as your website, app, social media pages, and more. Link clicks (PV) will be tracked.',
    },
    leads: {
      title: 'Leads',
      desc: 'Collect leads for your business or brand. Encourage customers to take action.',
    },
  },

  // 成功模态框
  successModal: {
    congratulations: 'Congratulations! Your campaign is created and will receive influencer applications within 24–48 hours after review.',
    congratulationsColdEmail: 'Congratulations! Your campaign is created.',
    descriptionGuide: 'In the meantime, get an overview of essentials of AhaCreator to help you maximize your success',
    descriptionColdEmail: 'We\'re now setting up your email domain and accounts. The email warmup process typically takes at least 7 days, after which we will start sending out invites.',
    descriptionNormal: 'In the meantime, check campaign details or get an overview of essentials of AhaCreator to help you maximize your success',
    viewCampaign: 'View campaign',
    importantSeeNext: 'Important: see what happens next',
    checkHeadInstructions: 'Check AhaCreator Instructions',
  },

  // 高级设置
  advancedSetting: {
    title: 'Advanced settings',
  },

  // 设置页面
  settings: {
    title: 'Settings',
    save: 'Save',
    cancel: 'Cancel',
    saveSuccess: 'Save success!',
    placements: 'Placements',
    languages: 'Languages',
    locations: 'Locations',
    targetingSectionTitle: 'Targeting',
    searchCountryOrRegionPlaceholder: 'Search country/region',
    pleaseSelectAtLeastOneLanguage: 'Please select at least one language',
    influencerMarketingPostDate: 'Influencer marketing post date',
    affiliateMarketingContentPostDate: 'Affiliate marketing content post date',
    landingPageLink: 'Provide the link where the audience will be taken when they click',
    selectAll: 'Select All',
    pleaseSelectAtLeastOnePlatform: 'Please select at least one platform content type',
    pleaseSelectAtLeastOneRegion: 'Please select at least one region',
    pleaseSelectPostDate: 'Please select post date',
    flexiblePostTime: 'Flexible post time: Creators can publish their content as soon as it\'s approved.',
    fixedPostTime: 'Fixed post time: Creators are required to post within a designated time window.',
    selectCampaignStartDates: 'Select campaign start dates at least one month in advance to ensure influencers have ample time to produce content.',
    influencersRequiredToPost: 'Influencers are required to post content within 7 days after their applications are approved',
    currentSelectionMayLimit: 'Your current selection may limit influencer matches. To improve results, try selecting more platforms, languages, or locations to broaden your reach.',
    selectedPlatformsMayLimit: 'Selected platforms may limit your campaign\'s reach. To maximize performance, please consider including more platforms.',
    chooseSocialPlatforms: 'Choose the social platforms and content types you would like the influencers to engage with.',
    enterLanguageToShowAds: 'Enter a language to show your ads to people who use the language.',
    chooseBroadAreaToShowAds: 'Choose a broad area to show your ads within can improve results.',
    specifyParticularDateWindow: 'Specify if you have a particular date window in mind for when you would like the influencers to post their content.',
    influencerPostDeadlineTitle: 'Influencer post deadline',
    earliestPostDateLabel: 'Earliest post date',
    latestPostDateLabel: 'Latest post date',
    latestPostDateVerySoonTitle: 'Latest post date is very soon',
    latestPostDateVerySoonDescription: 'Your latest post date is {date}, just {days} days out. Short lead times lower influencer application rates and raise pricing. Consider pushing it out.',
    latestPostDatePassedTitle: 'Latest post date has passed',
    latestPostDatePassedDescription: 'Your latest post date was {date}. An expired date makes influencers unsure if this campaign is still open, which can hold up collaborations. Please push the date out.',
    earliestPostDateBeforeToday: 'Earliest post date cannot be before today',
    latestPostDateAfterEarliest: 'Latest post date must be on or after earliest post date',
    trackingLinkDescription: 'AhaCreator will generate a unique tracking link for each influencer from this link to help you track performance (e.g., views, clicks, CPM, and CPC).',
    influencerLink: {
      promotionalLinkRequirementTitle:
        'Does this campaign require influencers to include a promotional link?',
      promotionalLinkRequirementRequired:
        'Please select whether influencers are required to include a promotional link',
      promotionalLinkRequiredLabel: 'Yes, a promotional link is required',
      noPromotionalLinkRequiredLabel: 'No promotional link is required',
      title: 'How would you like to provide the promotional links?',
      selectModeRequired:
        'Please select how you would like to provide the promotional links',
      autoLabel: 'Let AhaCreator generate unique links',
      autoDesc:
        'AhaCreator will create a unique tracking link for each influencer based on your destination URL, so you can track performance by influencer (views, clicks, CPM, CPC).',
      manualLabel: 'Use my own unique links',
      manualDesc:
        'After you confirm a collaboration, you can assign a unique link to each influencer on the platform. AhaCreator will track views and CPM only.',
    },
    coldEmailSettings: 'Cold email',
    emailSenderName: 'Email sender name',
    letAIAgentSetCPM: 'Let AI agent set the CPM',
    letAIAgentSetCPMDesc: 'Let AI agent set the CPM for you. Good for brands that have no CPM limit',
    smartMode: 'Smart mode',
    setMaximumCPMManually: 'Set maximum CPM manually',
    setMaximumCPMManuallyDesc: 'Set maximum CPM cap manually. Good for brands that have strict CPM limit',
    manualMode: 'Manual mode',
    letAIAgentNegotiatePrice: 'Let AI agent negotiate the price',
    letAIAgentNegotiatePriceDesc: 'Let AI agent negotiate the best price for you. Good for brands that have no budget limit for each influencer',
    setPriceLimitsManually: 'Set price limits manually',
    setPriceLimitsManuallyDesc: 'Set the influencer budget manually. Good for brands that have strict budget limit',
    highestBudgetPerInfluencer: 'Highest budget per influencer',
    lowestBudgetPerInfluencer: 'Lowest budget per influencer',
    emailSenderTitle: 'Email sender title',
    emailToForwardConvertedLeads: 'Email to forward converted leads',
    pleaseEnterEmailSenderName: 'Please enter email sender name',
    pleaseEnterEmailSenderTitle: 'Please enter email sender title',
    pleaseEnterEmailSenderForwardEmail: 'Please enter email sender forward email',
    pleaseEnterValidName: 'Please enter a valid name',
    pleaseEnterValidEmailAddress: 'Please enter a valid email address',
    advancedInfluencerSettings: 'Advanced influencer settings',
    influencerFilterWarning: 'Please note that applying influencer filter logic will limit your influencer supply. Please set with caution.',
    influencerSettings: {
      performanceActivity: 'Performance & activity',
      minimumPredictedViews: 'Median view range',
      minimumPredictedViewsTooltip: 'AhaCreator uses historic data to predicted views for influencers. If you don\'t set, the default predicted view threshold is YouTube: 400, TikTok: 1500, Twitter: 700, LinkedIn: 500, Instagram: 1500',
      predictedViewsRange: 'View range',
      predictedViewsRangeNoMaxPlaceholder: 'No upper limit',
      predictedViewsRangeMaxMustBeGteMin:
        'Max must be greater than or equal to min',
      minimumFollowers: 'Minimum followers',
      followersRange: 'Followers range',
      postingFrequency: 'Posting frequency',
      postingFrequencyRequired: 'Please input the posting frequency',
      postsPerMonth: 'posts per month',
      lastPostTime: 'Last post time',
      lastPostTimeRequired: 'Please input the last post time',
      lastPostWithin: 'Last post within',
      lastPostTimeYoutubeWarningTitle: 'Too strict for YouTube',
      lastPostTimeYoutubeWarningDescription:
        'YouTube influencers post less often, so a {days}-day window may cut most of your matches. Try 60 to 90 days.',
      price: 'Price',
      maximumCpm: 'Maximum CPM',
      maximumPricePerInfluencer: 'Maximum price per influencer',
      minimumPricePerInfluencer: 'Minimum price per influencer',
      audience: 'Audience',
      audienceGender: 'Audience gender',
      genderRequired: 'Please select the gender',
      female: 'Female',
      male: 'Male',
      percentRequired: 'Please input a percentage',
      audienceGenderDesc: 'Select the primary gender in the influencer\'s audience and the minimum percentage required.',
      audienceAge: 'Audience age',
      ageRangeRequired: 'Please select the age range',
      audienceAgeDesc: 'Select one or more age ranges and the minimum audience percentage required.',
      audienceLocation: 'Location',
      audienceLocationPlaceholder: 'Select countries',
      minLocationPercentage: 'Min location percentage',
      audienceLocationMore: 'More',
      audienceLocationLess: 'Less',
      selectAll: 'Select all',
      recentActivity: 'Recent activity',
      fineTuneAdvancedTargetingTitle: 'Advanced targeting',
      fineTunePerformanceFiltersTitle: 'Performance filters',
      fineTunePerformanceFiltersTooltip:
        'Enabling many performance filters significantly reduces influencer matches. Unless a metric is critical to your campaign, we recommend leaving it off and letting AhaCreator optimize based on the full influencer analysis.',
      fineTuneAudienceFiltersTitle: 'Audience filters',
      fineTuneAudienceFiltersTooltip:
        'Narrow audience filters significantly reduce influencer matches. We recommend keeping filters broad (or leaving them off) and letting AhaCreator find the best fit based on the full influencer analysis.',
      fineTuneMaximumCpmTooltip:
        'A strict CPM cap can exclude high-quality influencers whose overall ROI is still strong. We recommend leaving it open or setting a generous limit.',
      fineTuneMaximumPricePerInfluencerTooltip:
        "AhaCreator's counteroffer feature lets you negotiate with higher-priced matches. Set a higher max to work with more influencers and expand your collaboration opportunities.",
      priceLimitSameAllPlatforms: 'Same for all platforms',
      priceLimitCustomizePerPlatform: 'Customize per platform',
      cpmNoLimitPlaceholder: 'No limit',
      maximumPriceFieldPlaceholder: 'No maximum',
      maximumPriceGlobalFieldPlaceholder: 'No maximum price per influencer',
      minimumPlaceholder: 'Minimum',
      noMinimumPlaceholder: 'No minimum',
      above: 'Above',
      engagementRateTooltipYoutube:
        "Median engagement rate across the influencer's 20 most recent videos. For each video, it is calculated as (likes + comments) ÷ views.",
      engagementRateTooltipInstagram:
        "Median engagement rate across the influencer's 20 most recent posts. For each post, it is calculated as (likes + comments) ÷ views.",
      engagementRateTooltipTiktok:
        "Median engagement rate across the influencer's 20 most recent videos. For each video, it is calculated as (likes + comments + shares + saves) ÷ views.",
      engagementRateTooltipTwitter:
        "Median engagement rate across the influencer's 20 most recent tweets. For each tweet, it is calculated as (likes + comments + shares + saves) ÷ views.",
      engagementRateTooltipLinkedIn:
        "Median engagement rate across the influencer's 20 most recent posts. For each post, it is calculated as (likes + comments) ÷ views.",
      minGenderPercentage: 'Min gender percentage',
      audienceAgeRange: 'Age range',
      minAgePercentage: 'Min age percentage',
      audienceGenderOptionAny: 'Any',
      audienceGenderOptionFemaleDominant: 'Female dominant',
      audienceGenderOptionMaleDominant: 'Male dominant',
      fineTuneInfluencerAttributesTitle: 'Influencer attributes',
      fineTuneInfluencerAttributesTooltip:
        'Enabling many influencer attribute filters significantly reduces influencer matches. Unless a metric is critical to your campaign, we recommend leaving it off and letting AhaCreator optimize based on the full influencer analysis.',
      fineTuneInfluencerGenderTitle: 'Influencer gender',
      fineTuneInfluencerGenderOptionMale: 'Male',
      fineTuneInfluencerGenderOptionFemale: 'Female',
      fineTuneInfluencerAgeTitle: 'Influencer age',
      fineTuneInfluencerAgeOptionUnder18: 'Under 18',
      fineTuneInfluencerAgeOption18To34: '18-34',
      fineTuneInfluencerAgeOption35To64: '35-64',
      fineTuneInfluencerAgeOptionAbove64: 'Above 64',
      fineTuneInfluencerEthnicityTitle: 'Influencer ethnicity',
      fineTuneInfluencerEthnicityOptionWhite: 'White',
      fineTuneInfluencerEthnicityOptionBlack: 'Black',
      fineTuneInfluencerEthnicityOptionAsian: 'Asian',
      fineTuneInfluencerEthnicityOptionHispanicLatino: 'Hispanic / Latino',
      fineTuneInfluencerEthnicityOptionMiddleEastern: 'Middle Eastern',
      fineTuneInfluencerEthnicityOptionOther: 'Other',
      fineTuneOnCameraTitle: 'On-camera',
      fineTuneOnCameraOptionOnCamera: 'On-camera',
      fineTuneOnCameraOptionAvatarVirtual: 'Avatar / Virtual',
      fineTuneOnCameraOptionFaceless: 'Faceless',
      fineTuneVoiceoverTitle: 'Voiceover',
      fineTuneVoiceoverOptionMustHave: 'Must have voiceover',
      fineTuneVoiceoverOptionNoPreference: 'No Preference',
      fineTuneTikTokShopAffiliateTitle: 'TikTok Shop Affiliate',
      fineTuneTikTokShopAffiliateOptionSupports: 'Supports Affiliate',
      fineTuneTikTokShopAffiliateOptionNoPreference: 'No Preference',
    },
    emailSenderNamePlaceholder: 'This will serve as sender name for your cold emails',
    emailSenderTitlePlaceholder: 'This will serve as sender\'s title for your cold emails',
    emailForwardPlaceholder: 'We will forward hot quality leads to this email',
    developedEnglishSpeakingMarkets: 'Developed English-speaking markets',
    developedMarkets: 'Developed markets',
    developedAndEmergingMarkets: 'Developed and emerging markets',
    locationBagsDescription: 'Click a location group above to quickly add predefined countries/regions.',
    productExplainerVideo: 'Product explainer video',
    productExplainerVideoDesc: 'Upload a YouTube video explaining your products or service to help creators better understand your campaign requirements.',
    customBrandGuidelines: 'Custom brand guidelines',
    customBrandGuidelinesDesc: 'Requirements that you\'d like the creators to follow in addition to',
    platformRequirements: 'Platform requirements.',
    customBrandGuidelinesDescEnd: 'If you already have a campaign brief prepared, you’re welcome to include it here.',
    referenceInfluencers: 'Reference influencers',
    referenceInfluencersDesc: 'Upload a list of influencers you like, and AhaCreator will find similar ones for your campaign.',
    downloadTemplate: 'Download template',
    blocklist: 'Blocklist',
    blocklistDesc: 'Upload a list of influencers you do not wish to work with.',
    brandAssets: 'Brand assets',
    brandAssetsDesc: 'Upload the brand assets you wish to share with creators via Google Drive or other links. Please adhere to the',
    brandAssetsUploadRequirements: 'Brand assets upload requirements',
    brandAssetsDescEnd: 'so that creator content can achieve optimal results.',
    add: 'Add',
    upload: 'Upload',
    pleaseInputValidYoutubeLink: 'Please input Valid Youtube Link!',
    pleaseInputValidLink: 'Please input Valid Link!',
    pleaseEnterBrandAssetsLink: 'Please enter the Brand assets link...',
    mustUsePlaceholder: 'e.g. Must use xxx features.',
    theFileDoesNotContain: 'the file does not contain any influencer profile',
    notice: 'NOTICE',
    confirmToAdd: 'Confirm to add',
    notNow: 'Not now',
    kindReminder: 'Kind reminder',
    youHaveSelectedCountriesOrLanguages: 'You have selected the following countries or langauges:',
    doYouWantToAddRecommended: 'Do you want to add the following recommended languages or countries?',
    pricingPlan: 'Pricing plan',
    freelancingModel: 'Freelancing model',
    payAsYouGo: 'Pay as you go',
    commissionDescription: 'Our commission is 10% for each influencer collaboration.',
    employmentModel: 'Employment model',
    yearly: 'Yearly',
    twoMonthsFree: '2 months free / year',
    noCommissionsDescription: 'No commissions, 7.9% of your influencer marketing budget / mo. Save',
    vsPayAsYouGo: 'vs pay-as-you-go.',
    affiliateMarketing: 'Affiliate marketing',
    affiliateRecruitmentBudget: 'Affiliate recruitment budget',
    affiliateRecruitmentBudgetDesc: 'Total budget to recruit affiliates through AhaCreator. You\'ll only be charged when you confirm influencers to join, and commissions are paid separately after they generate sales. Affiliate costs usually range from a few dollars up to $100.',
    pleaseSelectBudgetForAffiliate: 'Please select budget',
    affiliateCommissionRate: 'Affiliate commission rate',
    pleaseEnterAffiliateCommissionRate: 'please enter affiliate commission rate',
    industryBenchmarkCommission: 'Industry benchmark: 10%- 80%',
    averageOrderValue: 'Average order value',
    pleaseEnterAverageOrderValue: 'Please enter average order value',
    industryBenchmarkOrder: 'Industry benchmark: 50-500 USD(B2B), 10-100 USD(B2C)',
    coldEmail: 'Cold email',
    coldEmailDescription: 'You\'ll be prompted to make a payment of 30 USD to cover basic costs including domain set up fee, emails warmup fee, email outreach fee, etc. when you launch your campaign.',
    budgetToAcquireConvertedLeads: 'Budget to acquire converted leads',
    pleaseSelectBudgetForLeads: 'Please select budget',
    positiveResponseRateOutOfSentEmails: 'Positive response rate out of sent emails',
    pleaseEnterPositiveReplyRate: 'please enter positive reply rate',
    industryBenchmarkResponseRate: 'Industry benchmark: 3% – 10% (B2B), 1% – 5% (B2C)',
    positiveResponseToPurchaseRate: 'Positive response to purchase rate',
    pleaseEnterConversionRate: 'please enter converison rate',
    industryBenchmarkConversionRate: 'Industry benchmark: 8% – 25% (B2B), 3% – 15% (B2C)',
    averageCustomerLifetimeValue: 'Average customer lifetime value',
    pleaseEnterAverageCustomerLifetimeValue: 'Please enter average customer lifetime value',
    // 其他设置相关文本
    placementsInfoModal: {
      title: 'Platform Content Formats & Use Cases',
      platform: 'Platform',
      contentFormat: 'Content Format',
      keyFeatures: 'Use Cases',
      youtubeDedicated: 'Dedicated videos',
      youtubeIntegrated: 'Integrated videos',
      instagramReel: 'Reels',
      instagramCarouselPost: 'Carousel posts',
      tiktokVideo: 'Videos',
      Posts: 'Posts',
      youtubeDedicatedDesc: 'Full video entirely focused on the brand — best for new product launches, in-depth reviews, or brand storytelling.',
      youtubeIntegratedDesc: "Branded segment within an influencer’s video. A cost-efficient option for natural but substantial exposure.",
      instagramReelDesc: 'Short videos, strong algorithm reach — great for product launches, viral trends, and quick brand exposure.',
      instagramCarouselPostDesc: 'Up to 10 slides, mix of images and videos. Ideal for storytelling, product demos, comparisons, and tutorials.',
      tiktokVideoDesc: 'Vertical short videos mixed into user feed — powerful for mass reach, creative storytelling, and young audiences.',
      twitterPostDesc: 'Flexible posts with text, images, or videos — suited for topical engagement, brand voice, and viral reach.',
      linkedinImagePostDesc: 'Branded visuals or carousel posts showing product value, insights, or collaborations — ideal for professional storytelling and credibility building.',
      linkedinVideoPostDesc: 'Influencer-led videos sharing use cases, expert opinions, or testimonials — strong for trust-building and engagement among decision-makers.',
      linkedinImagePost: 'LinkedIn image posts',
      linkedinVideoPost: 'LinkedIn video posts',
      linkedinPostDesc: 'LinkedIn video or carousel post that showcase product value, insights, collaborations, and real-world use cases — ideal for building professional credibility, trust, and engagement among decision-makers.',
    },
    twitterPostTooltip: "X may include more engagement pods. Please vet accounts carefully and confirm a fair rate before partnering.",
    languageMissPanel: {
      title: 'Considering your target regions, you might want to add these languages:',
      addAll: 'Add All',
    },
    onlyCsvFiles: 'Only .csv files',
    matchingAccuracy: {
      title: 'Matching accuracy',
      focusMode: {
        label: 'Focus mode',
        desc: 'Focuses on highly aligned influencers for better match accuracy. Expect higher costs and a longer campaign cycle.',
      },
      scaleMode: {
        label: 'Scale mode',
        desc: 'Expands the influencer pool while keeping solid relevance, improving efficiency, lowering costs, and shortening the campaign cycle.',
      },
      maxScaleMode: {
        label: 'Max scale mode',
        desc: 'Maximizes reach by widening relevance boundaries, greatly lowering costs and accelerating the campaign cycle.',
      },
    },
  },

  // 业务信息
  businessInformation: {
    title: 'Business Information',
    companyName: 'Company Name',
    website: 'Website',
    industry: 'Industry',
    coreSellingPoints: 'Core selling points',
    coreAudiences: 'Core product audiences',
    advancedSettings: 'Advanced Settings',
    gender: 'Gender',
    age: 'Age',
    interest: 'Interest',
    aiGeneratedDescription: 'These details are generated by AhaCreator based on an analysis of your brand. Please review and customize them as necessary.',
    basicInformation: 'Basic information',
    businessLogo: 'Business Logo',
    logoFormatNote: 'Only support uploading logos in SVG format.',
    upload: 'Upload',
    businessName: 'Business name',
    productServiceType: 'Product / Service type',
    benchmarkBrands: 'Benchmark brands',
    importantMatters: 'Important Matters',
    importantMattersDescription: 'Please fill in any information that needs special attention from the creator below, such as: product usage prohibitions, essential points to mention, accounts to @tag, etc.',
    importantMattersPlaceholder: 'Important Matters...',
    businessIntroduction: 'Business introduction',
    pleaseEnterBusinessName: 'Please enter business name',
    pleaseEnterBenchmarkBrands: 'Please enter benchmark brands',
    benchmarkBrandsDescription: 'We’ll use your benchmark brands to match both influencers who are a great fit to promote them and those who’ve partnered with these brands before. Put the brands most similar to yours at the top to improve matching accuracy.',
    campaignName: 'Campaign name',
    pleaseEnterCampaignName: 'Please enter campaign name',
    pleaseSelectGender: 'Please select gender',
    pleaseSelectAge: 'Please select age',
    pleaseEnterInterests: 'Please enter the interests of the audience, separated by ","',
    pleaseFillInInfluencerAccessCredits: 'Please fill in the influencer access & credits information',
    endorsementPlaceholder: 'e.g., funding, major partners, traction, revenue...',
    endorsementPlaceholderDesc: 'Awards, press features, product certifications, funding, traction, user feedback, past collaborations—anything that makes creators feel excited to promote you and confident you\'re safe to back.',
    brandHighlightsEndorsements: 'Brand highlights & endorsements',
    pleaseEnterBusinessIntroduction: 'Please enter business introduction',
    forInfluencerMatching: {
      label: 'For influencer matching',
      tooltip: 'This information helps AhaCreator find influencers whose audience and content best match your campaign.',
    },
  },

  // 选择目标
  selectObjective: {
    title: 'Select Campaign Objective',
    awareness: 'Awareness',
    traffic: 'Traffic',
    leads: 'Leads',
    installs: 'Installs',
    signUps: 'Sign-ups',
    sales: 'Sales',
    // 其他目标相关文本
  },

  // 平台内容标签
  platformContentLabel: {
    or: ' or ',
    youtubeDedicated: 'YouTube dedicated video',
    youtubeIntegrated: 'YouTube integrated video',
    tiktokVideo: 'TikTok video',
    instagramReel: 'Instagram Reel',
    instagramCarouselPost: 'Instagram carousel post',
    twitterPost: 'Twitter(X) post',
    linkedinPost: 'LinkedIn posts',
    linkedinImagePost: 'LinkedIn image post',
    linkedinVideoPost: 'LinkedIn video post',
  },

  // 预算出价
  budgetBidding: {
    title: 'Budget & Bidding',
    dailyBudget: 'Daily Budget',
    totalBudget: 'Total Budget',
    budgetPerInfluencer: 'Budget per Influencer',
    budgetLimitWarning: 'Please set a reasonable budget limit for each influencer. An unreasonable budget limit may result in insufficient creator supply for your campaign. If you\'re unsure how to set a budget limit, recommend selecting Smart Mode.',
    chooseBudgetLimit: 'Choose your budget limit',
    maximumCpm: 'Maximum CPM',
    influencerMarketing: 'Influencer marketing',
    totalInfluencerPayment: 'Total influencer payment',
    totalBudgetDescription: 'Set your total campaign budget — you can adjust it anytime after launch. Payments are only processed after content delivery, and your budget determines how many influencers can be invited to your campaign.',
    pleaseSelectBudgetForInfluencer: 'Please select budget',
    name: 'Name',
    followers: 'Followers',
    estViewsPerPost: 'Est. views/post',
    matchReason: 'Match reason',
    profile: 'Profile',
    view: 'View',
    sampleInfluencersTitle: 'Sample influencers you may collaborate with',
    sampleInfluencersDesc: 'Based on the campaign information you provided, we\'ve pre-matched these sample influencers to help you assess audience fit. If they\'re not ideal, feel free to adjust your campaign inputs.',
    notSeeingIdealMatches: 'Not seeing ideal matches?',
    adjustYourInputs: 'Adjust your inputs',
    currentPlan: 'Current plan',
    perMonth: '/ mo',
    influencerFee: 'Influencer fee',
    verifyYourAuthorization: 'Verify your authorization',
    reviewCampaignTerms: 'Review campaign terms',
    campaignTermsDescription: 'Please review and acknowledge the terms that apply to this campaign.',
    terms: 'Terms',
    productSampleTerm: 'I understand that AhaCreator uses delivery milestones, reminders, and influencer ratings to reduce non-performance risks. However, if an influencer becomes unreachable after receiving a product sample, AhaCreator will make reasonable efforts to follow up but cannot guarantee its return or reimburse the brand.',
    cancellationTerm: 'I understand that if the collaboration is canceled for reasons attributable to the brand, such as when the brand decides to discontinue promotion of the product, the influencer is entitled to 30% of the order amount once a script or draft has been uploaded. If the final post link has been submitted and the brand withholds final approval without a reasonable stated basis, the influencer is entitled to 50% of the order amount.',
    pleaseAgreeToTerms: 'Please agree to the terms',
    pleaseProvideLegalName: 'Please provide your name',
    cancel: 'Cancel',
    authorizationDescription: 'To ensure the legal validity of your signed authorization document with AhaCreator, please provide your full legal name for official verification. Campaign cannot be released without successful authorization.',
    fullLegalName: 'Your name',
    nameVerificationDescription: 'To ensure the legal validity of your Partnership Authorization, please provide your name for official verification.',
    fullLegalNamePlaceholder: 'eg: John Doe',
    // Influencer application preview related
    influencerApplicationPreview: 'Influencer application preview',
    actualValuesMayFluctuate: 'Actual values may fluctuate due to factors such as market dynamics, influencer supply, and related conditions. The influencers displayed above are for preview and reference only; the final matching will occur once the campaign is released.',
    // Subscription related
    monthlySubscriptionCancellationRate: 'Monthly subscription cancellation rate',
    pleaseEnterMonthlySubscriptionCancellationRate: 'Please enter monthly subscription cancellation rate',
    industryBenchmarkSubscription: 'Industry benchmark: 1%-3% (B2B), 5%-10% (B2C)',
    clickToPurchaseRate: 'Click-to-purchase rate',
    pleaseEnterClickToPurchaseRate: 'Please enter click-to-purchase rate',
    industryBenchmarkClickToPurchase: 'Industry benchmark: 1% - 5%.',
    // Pay-as-you-go related
    clickToPayConversionRate: 'Click-to-pay conversion rate',
    pleaseEnterClickToPayConversionRate: 'Please enter click-to-pay conversion rate',
    payingUserARPU: 'Paying User ARPU',
    pleaseEnterPayingUserARPU: 'Please enter paying user ARPU',
    payingUserARPUDescription: 'The average revenue generated per paying user.',
    // Table column titles
    estimatedPrice: 'Estimated price',
    predictedCPM: 'Predicted CPM',
    predictedViews: 'Predicted views',
    predictedCPC: 'Predicted CPC',
    predictedClicks: 'Predicted clicks',
    // Landing page URL related
    conversionTrackingAlert: 'Make sure the page you\'re directing traffic to is set up correctly to measure conversions. Conversion tracking helps you understand how effectively your ad clicks lead to valuable customer activity and optimize your ads for those actions. Learn more:',
    viewHeadDevelopmentDoc: 'View AhaCreator Development Doc',
    pleaseEnterValidLink: 'Please enter a valid link',
    landingPagePlaceholder: 'The audience will visit this link after watching the influencer\'s content',
    back: 'Back',
    continue: 'Continue',
    partnershipAuthorization: 'Partnership Authorization',
    authorizationText1: 'By confirming this, you\'re officially authorizing AhaCreator',
    authorizationText2: '(operated by Ahalab.ai Inc.) to manage this campaign on your behalf.',
    authorizationDescription1: 'This authorization document will be visible to influencers when they receive tasks, giving them confidence that the partnership is legitimate. This streamlines the process and reduces unnecessary back-and-forth.',
    authorizationDescription2: 'While most influencers won\'t need further confirmation,',
    authorizationDescription2Highlight: 'some may still reach out to verify directly with you and your team.',
    authorizationDescription2End: 'You can choose to respond or ignore these messages - our support team handles all follow-ups to keep things running smoothly.',
    reminder: 'Reminder',
    iConfirmAuthorization: 'I Confirm Authorization',
    workEmailCheckTitle: 'Quick check: confirm you represent this brand',
    sensitiveIndustryNotice: 'We noticed this campaign relates to a sensitive industry. To help us verify the legitimacy of the brand, please upload supporting documents — such as business license, or any other supporting documentations.',
    workEmailCheckDescription: 'Your work email doesn\'t match the campaign website\'s domain, so we need a quick confirmation that you\'re authorized to run campaigns for this brand. This keeps influencers confident they\'re working with the right team. Anything that shows your connection works, for example:',
    workEmailProof1: 'A business card or signature',
    workEmailProof2: 'An authorization letter from the brand',
    workEmailProof3: 'A screenshot of your team\'s workspace on any collaboration tool (e.g., Slack, Teams, Lark)',
    upload: 'Upload',
    modalBack: 'Back',
    modalContinue: 'Continue',
    ifYouNeedAssistance: 'If you need any assistance, don\'t hesitate to',
    contactUs: 'contact us.',
    fileSizeExceedError: 'The file size cannot exceed 10MB!',
    failedToUploadLogo: 'Failed to upload logo',
    setCpmCap: 'Set your CPM cap',
  },

  // 预览匹配
  previewSampleMatches: {
    title: 'Preview Sample Matches',
    saveSuccess: 'Save success!',
    feedbackTitle: 'Preview sample matches to align expectations',
    feedbackDescriptionLoading: 'You can adjust match accuracy, business introduction, selling points, core audience, or desired influencer profiles to refine the samples.',
    feedbackDescriptionFocusMode: 'Here are samples generated in Focus mode. Not meeting expectations? Adjust match accuracy, business introduction, selling points, core audience, or desired influencer profiles to refine results.',
    feedbackDescriptionScaleMode: 'Here are samples from Scale mode (includes Focus). Not meeting expectations? Adjust match accuracy, business introduction, selling points, core audience, or desired influencer profiles to refine results.',
    feedbackDescriptionMaxScaleMode: 'Here are samples from Max mode (includes Focus and Scale). Not meeting expectations? Adjust match accuracy, business introduction, selling points, core audience, or desired influencer profiles to refine results.',
    notGettingRightMatches: 'Not getting the right matches?',
    highNotMatchRateMessage: 'Over 40% of influencers were marked “Not a match.” This suggests some parts of your campaign info, such as <b>match accuracy, business introduction, selling points, core audience, or desired influencer profiles</b>, may need refinement.\nWould you like AhaCreator to auto-optimize these sections? Your manual edits will remain unchanged.',
    moreThan40Percent: 'More than 40% of the creators you reviewed were marked as',
    notAMatchPeriod: 'Not a match .',
    thisUsuallyMeansInfo: 'This usually means your campaign information',
    likeAudienceCore: '(like audience, core selling points, etc. )',
    mayNeedFineTuned: 'may need to be fine-tuned to improve accuracy. Would you like to review and refine your setup now?',
    continueAnyway: 'Continue anyway',
    editCampaignInfoManually: 'Edit campaign info manually',
    optimizeWithAI: 'Optimize with AI',
    matchReason: 'Match reason',
    match: 'Match',
    emptyMessage: 'We’re preparing sample matches to fine-tune your results. This process takes about 2 minutes.',
    emptyMessage2: 'Initial test matches help validate the direction before running the full influencer matching.',
    emptyMessageTips: 'This is a test match, not the final matching result.',
    endCard: {
      description: "Your initial match looks great! Based on your feedback, we’ll move forward to the official matching stage to connect you with the most relevant influencers once your campaign goes live.",
      return: 'Update your feedback',
      notMatchDesc: 'To improve the quality and relevance of your influencer matches, we recommend adjusting your campaign information. You can let our AI assistant instantly optimize your campaign or ',
      notMatchDescLink: 'contact us for help.',
      next: 'Next',
      expandWithAISuggestions: 'Optimize campaign info with AI',
      adjustMatchingAccuracyMode: 'Adjust matching accuracy mode'
    },
    notAMatch: 'Not a match',
    emptyMessageTime: '2min',
    timeSecond: 's',
    timeMinute: 'min',
    timeMinutes: 'mins',
  },

  // 创建估算面板
  createEstimatePanel: {
    estimatedCampaignResults: 'Estimated campaign results',
    affiliateMarketingResultsEstimation: 'Affiliate marketing results estimation',
    coldEmailResultsEstimation: 'Cold email results estimation',
    views: 'Views',
    cpm: 'CPM',
    clicks: 'Clicks',
    cpc: 'CPC',
    costPerInstallRange: 'Cost per install range',
    installRange: 'Install range',
    costPerLeadRange: 'Cost per lead range',
    leadRange: 'Lead range',
    costPerSignUpRange: 'Cost per sign-up range',
    signUpRange: 'Sign-up range',
    roiRange: 'ROI range',
    salesRange: 'Sales range',
    arpuCacRange: 'ARPU/CAC range',
    aovCacRange: 'AOV/CAC range',
    cpmAcrossDifferentPlatforms: 'CPM across different platforms',
    numberOfAffiliates: 'Number of affiliates',
    noteSalesEstimates: 'Note: Sales estimates are calculated using industry click-to-purchase conversion benchmarks ranging from 1.5% to 4.5%.',
    potentialConvertedLeads: 'Potential converted leads',
    potentialCustomers: 'Potential customers',
    potentialLifetimeRevenue: 'Potential lifetime revenue',
    roi: 'ROI',
  },

  // 受众
  audiences: {
    title: 'Audiences',
    // 其他受众相关文本
  },

  // 创意
  creatives: {
    title: 'Creatives',
    // 其他创意相关文本
  },

  // 开发策略
  developStrategy: {
    title: 'Develop Strategy',
    // 其他策略相关文本
  },

  // 增长策略
  growthStrategy: {
    title: 'Growth Strategy',
    // 其他增长相关文本
  },

  // 活动创意
  campaignIdeas: {
    title: 'Campaign Ideas',
    // 其他创意相关文本
  },

  // 活动步骤
  campaignSteps: {
    setupCampaign: 'Set up campaign',
    basicInformation: 'Basic information',
    settings: 'Settings',
    previewSampleMatches: 'Preview sample matches',
    budgetAndResults: 'Budget and results',
    reviewSummary: 'Review summary',
    collapse: 'Collapse',
  },

  // 选择交付模式
  selectDeliveryMode: {
    title: 'Select Delivery Mode',
    serviceModel: 'Service Model',
    contactUsMessage: 'Please contact us to get a free crash course on creator marketing before you release the campaign.',
    serviceModelComparison: 'Service Model Comparison',
    // 其他交付模式相关文本
  },

  // 产品分析
  productAnalysis: {
    title: 'Product Analysis',
    // 其他产品分析相关文本
  },

  // 审核摘要
  reviewSummary: {
    title: 'Review Summary',
    // 其他审核相关文本
  },

  // 添加Stripe
  addStripe: {
    title: 'Add Stripe',
    // 其他Stripe相关文本
  },

  // 落地页URL
  landingPageUrl: {
    title: 'Landing Page URL',
    // 其他落地页相关文本
  },

  // 其他信息
  otherInformation: {
    title: 'Other Information',
    // 其他信息相关文本
  },

  // 进度时间线
  progressTimeline: {
    title: 'Progress Timeline',
    editCampaign: 'Edit Campaign',
    headThinking: 'AhaCreator is thinking...',
    headFinished: 'AhaCreator finished thinking.',
    noMoreInfluencers: 'There are currently no more suitable influencers that match your campaign. If you\'d like to find additional influencers, please consider editing your campaign details. I will then identify and reach out to more influencers based on your updated campaign information.',
    // 其他进度相关文本
  },

  // 网站表单
  websiteForm: {
    title: 'Website Form',
    welcomeMessage: 'Hi {firstName}! Happy to partner with you to build real marketing strategies and run an expert-level campaign. Drop your website URL and I’ll review it, offering a brand overview we can refine together. It also helps me identify the best-fit influencers for your brand.',
    welcomeMessageNoName: 'Hi! Happy to partner with you to build real marketing strategies and run an expert-level campaign. Drop your website URL and I’ll review it, offering a brand overview we can refine together. It also helps me identify the best-fit influencers for your brand.',
    pleaseEnterWebsite: 'Please enter a website',
    pleaseEnterValidWebsite: 'Please enter a valid website',
    websitePlaceholder: 'Enter your product or app website, Amazon link, Shopify link, etc.',
    generate: 'Generate',
    errorOccurred: 'An error occurred. Please try again.',
    // 其他网站表单相关文本
  },
  websiteLoading: {
    settingUpCampaign: 'Setting up campaign',
    readStory: 'Read story',
  },

  // V4 创建活动 — Brief 步骤
  v4Brief: {
    back: 'Back',
    analyzingTitle:
      'Analyzing your needs and setting up your campaign. This takes about 2 minutes.',
    headline:
      "Share a product link or brief, and we'll draft your influencer strategy and content guidelines for you to review and edit.",
    textareaPlaceholder:
      "Share what you're promoting: paste a product URL, describe your campaign, or upload a brief.",
    uploadBrief: 'Upload campaign brief',
    start: 'Start',
    inaccessibleLinkTitle: "Can't access this link",
    inaccessibleLinkHint:
      'Make this link viewable to anyone with access, then paste again: ',
    manualSetup: 'No product link or brief? Build your campaign step by step',
    /** Fine-tune step — inline brief editor (upload strip + post-save strategy modal) */
    fineTuneCardTitle: 'Product link or brief you shared',
    dragUploadLeading: 'Click to upload or drag & drop',
    dragUploadSeparator: '-',
    dragUploadFormats: 'PDF, DOCX, PPT',
    afterBriefSaveStrategyModalTitle:
      'Brief updated. Update your influencer strategy?',
    afterBriefSaveStrategyModalBody:
      "We'll re-evaluate your strategy based on the new brief, including influencer profiles, targeting (placements, locations, etc.) and advanced targeting settings.",
    keepCurrentStrategy: 'Keep current strategy',
    updateStrategy: 'Update strategy',
    missingCampaignId: 'Missing campaign id',
    saveFailed: 'Save failed',
    uploadFileFailed: 'Failed to upload file',
  },

  /** V4 — Set content guidelines (creator brief step) */
  v4SetContentGuidelines: {
    /** BriefInfluencer — collapsible creator brief editor */
    editorCardTitle: "Drop in your content brief. We'll structure it for you",
    headline:
      "Drop in your content brief. We'll structure it for you.",
    textareaPlaceholder:
      'Paste a content brief link from Google Docs, Notion, or Lark, or upload a file.',
    uploadBrief: 'Upload content brief',
    start: 'Start',
    inaccessibleLinkTitle: "Can't access this link",
    inaccessibleLinkHint:
      'Make this link viewable to anyone with access, then paste again: ',
    manualSetup: 'No content brief? Set up manually',
    back: 'Back',
  },

  /** V4 — Brief influencer step (page shell) */
  v4BriefInfluencer: {
    analyzingTitle:
      'Analyzing your content brief and structuring it. This takes about 40 seconds.',
    warmBannerMessage:
      'Invited influencers will see everything below on the AhaCreator creator platform, including any uploaded files. This helps them understand your campaign, product, and content requirements.',
    back: 'Back',
    setBudget: 'Next',
  },

  /** V4 — Brief influencer flow — campaign information */
  v4BriefInfluencerCampaignInfo: {
    campaignInformationSectionTitle: 'Campaign information',
    deliveryRequirementSectionTitle: 'Delivery requirement',
    productLogoLabel: 'Brand logo',
    productLogoRequired: 'Please upload a product logo',
    brandNameLabel: 'Brand name',
    brandNamePlaceholder: 'Please enter brand name',
    brandNameRequired: 'Please enter brand name',
    productNameLabel: 'Product name',
    productNamePlaceholder: 'Please enter product name',
    productNameRequired: 'Please enter product name',
    productTypeLabel: 'Product type',
    productTypeRequired: 'Please select product type',
    productLinkLabel: 'Product link',
    productLinkPlaceholder: 'www.example.com',
    productLinkRequired: 'Please enter product link',
    productLinkInvalid: 'Please enter a valid product link',
    productIntroductionLabel: 'Product introduction',
    productIntroductionRequired: 'Please enter product introduction',
    uniqueSellingPointsFeaturesLabel: 'Unique selling points & features',
    coreFeatureRequired: 'Please enter unique selling points & features',
    coreFeaturePlaceholder:
      'Smarter reasoning — the first AI image model that understands designer intent, not just keywords. Turns data tables into charts, handles spatial logic, metaphors, and negations. Precise partial editing — circle any region on canvas to edit, without re-generating the whole image.',
    campaignBackgroundLabel: 'Campaign background / goal (optional)',
    campaignBackgroundPlaceholder:
      'GOAL: Position Seedream 5.0 Lite as the world-first smartest AI image model - initiating a new era of AI-native creativity on Dreamina. CONTEXT: Dreamina\'s Seedream 5.0 Lite just went live as the world\'s first - a milestone moment in AI image generation. We\'re partnering with creators who care about AI tooling, creative workflow, and productivity to show what "the smartest image model ever shipped" actually means in practice. The AI image space is saturated with tools that generate pretty but literal results. Seedream 5.0 Lite is the first model that reasons — turning data tables into charts, understanding spatial logic and metaphors, and supporting precise region-based editing. We want creators to feel this difference, not just describe features.',
    campaignBackgroundHint:
      'Influencers produce sharper content when they know your goals. A few sentences is enough.',
    brandHighlightsEndorsementsLabel:
      'Why creators should trust you (shown in creator invite email, optional but recommended)',
    endorsementUploadButton: 'Upload image or file',
    endorsementLinkWarning:
      'Links in invitations trigger spam filters. Please remove this link from the text: ',
    endorsementMaxLength:
      'This shows up in the influencer invite email. Keeping it under 300 characters makes the email shorter, easier to read, and higher-converting.',
    removeEndorsementFile: 'Remove file',
    otherSettingsTitle: 'Other settings',
    otherSettingsOptionalBadge: '2 optional',
    productTutorialWalkthroughLabel: 'How to use the product (optional)',
    brandAssetsOptionalLabel: 'Brand assets (optional)',
    brandAssetsShareHint:
      'Upload the brand assets you wish to share with influencers via Google Drive or other links.',
  },

  /** V4 — Brief influencer — AhaCreator-facing brief (delivery step) */
  v4BriefInfluencerAhaCreatorBrief: {
    coreMessageLabel:
      'Core message you want influencers to share (optional)',
    creativeConceptLabel: 'Creative concept (optional)',
    referenceVideosLabel:
      'Reference videos from other influencers (optional but recommended)',
    referenceVideosPlaceholder: 'Paste video links, one per line',
    creativeConceptTips: {
      viewExample: 'View example',
      focusTitle: 'Focus',
      focusContent:
        'Show "The End of Manual Chasing" — turning what used to require a 10-person ops team into one marketer making one decision.',
      hookReferenceTitle: 'Hook reference',
      hookReferenceContent:
        '"I used to email 500 creators a week. Today I made one decision and went home." (Alt: "While my old marketing team was still in standup, AhaCreator had already shortlisted 80 creators, sent outreach, and flagged 3 risk profiles.")',
      visualReferenceTitle: 'Visual reference:',
      reference1Label: 'Reference 1:',
      reference1Content:
        'Split screen: LEFT "Yesterday\'s Marketing Ops": 10 people arguing on Slack, spreadsheets everywhere, late-night follow-ups, piles of missed creator replies. RIGHT "AhaCreator Agent": one person, one approval click, dashboard showing AI auto-executing outreach / timeline management / content review.',
      reference2Label: 'Reference 2:',
      reference2Content:
        'Split screen: LEFT: a one-line brief — "Find me 50 AI-savvy lifestyle creators in SEA with authentic audience and on-brand tone." RIGHT: live dashboard showing AI building the audience persona → scanning the 5M+ database → surfacing 80 matched creators, each with a reasoning chip explaining the match.',
      keyStatementTitle: 'Key statement',
      keyStatementContent:
        "Meet your new role: not the doer, but the decider. AhaCreator runs the operations. Your judgment is the only thing AI can't automate.",
      voFocusTitle: 'VO Focus',
      voFocusContent:
        'Emphasize that AhaCreator isn\'t "speeding up your workflow". It\'s "removing the operational layer entirely." AI runs the full chain end-to-end (discovery → outreach → timeline → review → delivery), so marketers reclaim the time once swallowed by repetitive execution and refocus on what only humans can do: strategy and judgment. Land on: "80,000+ verified creators. 5M+ database. One agent. Your judgment."',
    },
  },

  /** V4 — Brief influencer — how influencers receive the brief */
  v4BriefInfluencerReceiveBriefType: {
    questionLabel: 'How should influencers receive this brief?',
    requiredMessage:
      'Please select how influencers should receive this brief',
    ownBriefTitle: 'Use your own content brief doc',
    ownBriefDescription:
      'Attach your existing brief, or different versions for different influencer groups (e.g. tech, macro, etc.).',
    ahaBriefTitle: "Use AhaCreator's brief builder",
    ahaBriefDescription:
      'We pre-fill platform rules. You add your key message, creative direction, references, and more.',
  },

  /** V4 — Brief influencer — own brief document (Form.List row) */
  v4BriefInfluencerOwnBrief: {
    appliesToLabel: 'Specify which type of influencers this brief applies to',
    appliesToPlaceholder: 'Specify which type of influencers this brief applies to',
    appliesToRequired: 'Please enter who this brief version applies to',
    addBriefDocumentLabel: 'Add a content brief document',
    briefDocumentPlaceholder:
      'Paste content brief link, such as Google Doc, Notion, Lark, or upload a file',
    briefDocumentRequired: 'Please enter a brief link or upload a file',
    briefDocumentInvalidLink: 'Please enter a valid link',
    uploadBriefDocument: 'Upload',
    referenceVideosLabel: 'Reference videos (optional but recommended)',
    referenceVideosPlaceholder: 'Paste video links, one per line',
    addVersionButton: 'Add version',
  },

  /** V4 — Brief influencer — brief visibility timing */
  v4BriefInfluencerBriefVisibility: {
    questionLabel: 'When can influencers view the brief?',
    description:
      'Choose when influencers can access the brief, including the content requirements and reference videos.',
    invitationTitle: 'When they receive the invitation',
    invitationDescription:
      'This helps them evaluate the opportunity and align on content requirements earlier.',
    confirmedTitle: 'After the collaboration is confirmed',
    confirmedDescription:
      'Recommended for briefs containing confidential products, assets, or information.',
  },

  /** V4 — Brief influencer — script / idea submission before production */
  v4BriefInfluencerScriptIdea: {
    sectionTitle: 'Script / Idea submission',
    sectionDescription:
      'If required, the influencer is required to submit an idea or script to align on content direction before starting production.',
    optionRequireLabel: 'Require it (review before production)',
    optionSkipLabel: 'Skip it (influencers produce content directly)',
  },

  /** V4 — Brief influencer — delivery requirements (all / per platform) */
  v4BriefInfluencerRequirementsForm: {
    perPlatformSectionLabel: 'Per-platform requirements',
  },

  // V4 创建活动 — 微调策略 Wishlist
  v4Wishlist: {
    sectionTitle: 'Wishlist',
    sectionDescription:
      'AhaCreator will reach out to the influencers on your wishlist and invite them to join your campaign.',
    pasteLinksLabel: 'Paste links',
    orUploadSpreadsheetLabel: 'Or upload a spreadsheet with influencer profile URLs',
    wishlistTextPlaceholder:
      'Add influencer profile URLs here',
    spreadsheetDropzoneBeforeXlsx: 'Drag your ',
    spreadsheetDropzoneBetweenExtensions: ' or ',
    spreadsheetDropzoneAfterCsv: ' here, or click to browse',
    uploadedFileFallback: 'Uploaded file',
  },

  // V4 创建活动 — 微调策略 Matching Accuracy（与旧 settings.matchingAccuracy 三档不同，仅 Standard / Broad）
  v4FineTuneMatchingAccuracy: {
    sectionTitle: 'Matching Accuracy',
    standardLabel: 'Standard',
    standardDesc:
      'Balanced matching for most campaigns. Best for quality and relevance.',
    broadLabel: 'Max',
    broadDesc:
      'Wider matching to reach more influencers. Includes a broader range of influencers.',
  },

  // V4 创建活动 — 微调策略 Screening questions
  v4FineTuneScreeningQuestions: {
    answerType: "Answer type",
    freeText: "Free text",
    singleChoice: "Single choice",
    options: "Options",
    addOption: "Add option",
    optionLabel: "Option {number}",
    removeOption: "Remove option {number}",
    reorderOption: "Reorder option {number} using drag or arrow keys",
    optionRequired: "Please enter an option",
    minimumOptions: "Please add at least two options",
    duplicateOption: "Options must be unique",
    autoDisqualify: "Automatically disqualify influencers",
    disqualifyDescription: "Influencers who select the answer below won’t be able to express interest in this collaboration.",
    disqualifyingAnswer: "Disqualifying answer",
    disqualifyTooltip: "Influencers who select this answer won’t be able to express interest in this collaboration.",
    disqualifyingAnswerRequired: "Please select at least one disqualifying answer",

    sectionTitle: 'Screening questions',
    sectionDesc:
      'Add questions for influencers to answer when they apply, so you can quickly tell who fits this campaign.',
    questionLabel: 'Question #{number}',
    answerLabel: 'Answer',
    viewAllAnswers: 'View all answers',
    questionRequired: 'Please input your question',
    questionPlaceholder: 'input your question here',
    removeQuestion: 'Remove question',
    addQuestion: 'Add a question',
  },

  // V4 创建活动 — 微调策略 预览匹配卡片
  v4PreviewMatches: {
    whyInfluencerMatchesTitle: 'Recommendation reason',
    notAFit: 'Not a fit',
    saveToInviteList: 'Invite after launch',
    savedToInviteList: 'Saved to invite list',
    sampleMatchesTitle: 'Sample matches',
    sampleInfluencersBanner:
      'These are sample matches, not your final influencer list',
    sampleInfluencersDescription:
      'After launch, we\'ll match more influencers based on your strategy and send invitations. If the samples aren’t a good fit, update your strategy on the left and refresh the preview.',
    allSampleCreatorsReviewed:
      'You\'ve reviewed all sample creators. Click "Confirm strategy & Set budget" to move on to the next step.',
    noInfluencersMatchTitle: 'No influencers match your current criteria.',
    noInfluencersMatchHint:
      'Broaden your selection range to discover more creators who may be a good fit for your campaign.',
    /** 接口仅返回基础平台 slug 时的短标签（内容形态走 platformContentLabel + getPlatformContentLabel） */
    basePlatform: {
      youtube: 'YouTube',
      instagram: 'Instagram',
      tiktok: 'TikTok',
      twitter: 'Twitter',
      x: 'X',
      linkedin: 'LinkedIn',
    },
  },

  // V4 创建活动 — 微调策略「发布后保存」列表空状态（中间 tab 名与 FineTuneStrategyTabEnum.PREVIEW_MATCHES 一致）
  v4SavedForLaunch: {
    emptyStatePrefix: 'No influencers saved yet. Head to ',
    previewMatchesTab: 'Preview matches',
    emptyStateSuffix:
      " and save the ones that fit your campaign and they'll show up here, ready to invite after launch.",
    savedForLaunchTab: 'Saved for launch',
    savedForLaunchTabTooltip:
      "Added to invite list. They'll be invited first at launch.",
  },

  // V4 创建活动 — 微调策略页（整页加载、底栏）
  v4FineTuneStrategy: {
    sectionTitle: 'Influencer matching strategy',
    sectionDescription:
      'Apply your changes to refresh the sample matches shown on the right.',
    matchingLoadingTitle:
      'Matching creators to your creator profiles. Hang tight. This usually takes about 4 minutes',
    confirmStrategySetBudget: 'Next',
    updateMatches: 'Apply changes & refresh samples',
    generatingNewSamples: 'Generating new samples…',
  },

  // V4 微调 — 左侧更新后的重匹配提示
  v4FineTuneRematch: {
    title: "You've updated your strategy on the left.",
    description:
      'Want to rematch the sample influencers to make sure the matches at launch reflect your requirements?',
    rematchCta: 'Rematch',
    keepCta: 'Keep',
  },

  // V4 微调 — 右侧达人详情（部分为示例数据，占位用）
  v4FineTuneRightPanel: {
    keyMetricsTitle: 'Key metrics (recent 20 posts)',
    influencerRate: 'Rate history',
    historicalRateRange: 'Historical rate',
    historicalRateRangeTooltip:
      "Actual rates from this influencer's completed deals on AhaCreator, shown as lowest–highest across recent collaborations.",
    estimatedRateRange: 'Estimated rate',
    estimatedRateRangeTooltip:
      'No deal history yet. Estimated from recent deals by similar influencers, factoring in audience, niche, channel performance (e.g.average views, follower counts), and how well this influencer fits your brand.',
    followers: 'Followers',
    medianViews: 'Median views',
    engagementRate: 'Engagement rate',
    cpm: 'CPM',
    cpc: 'CPC',
    deliveryRecordTitle: 'Delivery record',
    completed: 'Completed',
    completionRate: 'Completion rate',
    averageDeliveryDays: 'Average delivery days',
    audienceDemographicsTitle: 'Audience demographics',
    verifiedData: 'Verified data',
    targetedRegions: 'Targeted regions',
    age: 'Age',
    gender: 'Gender',
    influencerInformationTitle: 'Influencer information',
    aiInferredBadge: 'AI inferred',
    influencerProfilesLabel: 'Influencer profiles',
  },

  v4FineTuneInfluencerInfo: {
    rows: {
      ageRange: 'Influencer age',
      gender: 'Gender',
      primaryLanguages: 'Primary Languages',
      languagesFluency: 'Languages Fluency',
      otherLanguages: 'Other Languages',
      ethnicity: 'Ethnicity',
      facePresentation: 'Face presentation',
      showsFace: 'Shows Face',
      voiceover: 'Voiceover',
      accent: 'Accent',
    },
    values: {
      female: 'Female',
      yes: 'Yes',
      no: 'No',
      native: 'native',
      dash: '-',
      accentDemo:
        "Clear, standard Australian accent with typical 'Gen Z' inflections and slang (e.g., 'it's giving,' 'tea').",
    },
  },

  v4FineTuneOnboarding: {
    step1Title: 'Fine-tune your influencer strategy with sample matches',
    step1Description:
      'Adjust your strategy on the left, preview matched influencers in the middle, and check details on the right.',
    step2Title: 'Tune any part of your strategy',
    step2Description:
      'Adjust profiles, targets, or advanced filters on the left. Each change reshapes the sample matches on the right.',
    step3Title: 'Sample influencers matched to your strategy',
    step3Description:
      'Save the ones you like to your invite list. They\'ll be invited automatically after launch. Mark "Not a fit" for the rest. These are just samples; AhaCreator will match many more influencers once you launch your campaign.',
    step4Title: 'Make confident decisions using data',
    step4Description:
      'Click any sample influencer to see metrics, audience demographics, and past brand work. Use the details to save the right ones, or skip with confidence.',
    totalStepsHint: 'A total of 4 steps',
    previous: 'Previous',
    done: 'Done',
  },

  // V4 创建活动 — 顶栏步骤条（与 StepsHeader/config 中 steps 顺序一致）
  v4StepsHeader: {
    buildCampaign: 'Build campaign',
    fineTuneStrategy: 'Fine-tune strategy',
    setContentGuidelines: 'Set content guidelines',
    setBudgetLaunch: 'Set budget & launch',
  },

  // V4 创建活动 — 设置预算并发布页
  v4SetBudgetAndLaunch: {
    pageTitle: 'Set terms, budget, and launch',
    launchCampaign: 'Launch Campaign',
    budgetSectionTitle: 'Campaign budget',
    totalCampaignBudgetLabel: 'Total campaign budget',
    usageRightsSectionTitle: 'Usage rights (affects pricing)',
    usageRightsSectionDescription:
      "Usage rights define how and how long you can use the influencer's content — for ads, reposts, or long-term use. More rights unlock more value, and typically come with a higher rate. Pick what matches your campaign needs.",
    usageRightsOptions: {
      none: 'None',
      days7: '7 days',
      days14: '14 days',
      days30: '30 days',
      days60: '60 days',
      days90: '90 days',
      months6: '6 months',
      year1: '1 year',
      no: 'No',
      yes: 'Yes',
    },
    usageRights: {
      linkInBioDuration: {
        title: 'Link in bio duration',
        description:
          'How long your promotional link stays in the bio for Instagram or TikTok influencers',
      },
      adAuthorizationCodeDuration: {
        title: 'Ad authorization',
        description:
          "Permission to run ads using the influencer’s post",
      },
      postRetentionDuration: {
        title: 'Post retention',
        description:
          'How long the influencer commits to keeping the post live on their profile.',
      },
      contentRepurposeRightsDuration: {
        title: 'Content repurpose rights',
        description:
          "Permission to reuse the influencer's content beyond the original post (e.g. repost, edit, ads).",
      },
      exclusivityDuration: {
        title: 'Exclusivity',
        description:
          'The influencer agrees not to promote competing brands or categories during the agreed exclusivity period.',
        subTitle: 'Specify categories or competitors',
        placeholder: 'e.g., Nike, Adidas, athletic footwear',
        requiredMessage: 'Please enter specify categories or competitors',
      },
      collaborativePost: {
        title: 'Instagram collaborative post',
        description:
          'The influencer publishes a Reel and tags your brand as a collaborator.',
        subTitle: 'Your brand Instagram account link',
        placeholder: 'e.g., https://www.instagram.com/_ahacreator',
        requiredMessage: 'Please enter your brand Instagram account link',
      },
    },
  },

  // V4 创建活动 — 选择内容类型（副标题无合适旧 key，主标题复用 settings.chooseSocialPlatforms）
  v4ChooseContentType: {
    subtitle: 'Choose all the platforms you want.',
  },

  // V4 创建活动 — 选择国家/地区（占位符复用 bookDemo.placeholders.country）
  v4ChooseCountries: {
    title: 'Which countries/markets are you targeting?',
    searchPlaceholder: 'Search country/region',
    selectedCountriesTitle: 'Selected countries ({count})',
    clearAll: 'Clear all',
    moreSelectedCount: '+ {count} ...',
    quickSelectionsTitle: 'Quick selections',
    byRegionTitle: 'By region',
  },

  // V4 创建活动 — 浏览量要求
  v4ViewCountRequirement: {
    title: 'Any median view count requirements for influencers?',
    subtitle:
      'These are our minimum thresholds to ensure influencer quality. Adjust if you want stricter criteria.',
  },

  // V4 创建活动 — 设置画像输入（Settings Profiles）
  v4SettingsProfiles: {
    title: 'Generate matching influencer profiles for your campaign',
    subtitle:
      "Paste reference influencers, benchmark products, or describe them in your own words. We'll generate matching profiles.",
    generateProfile: 'Generate Profile',
    productUrlLabel: 'Brand or product URL',
    productUrlPlaceholder:
      'Promote your brand with a brand link, or a single product with a product link.',
    productDescriptionLabel: 'Product description',
    productDescriptionPlaceholder:
      'Describe your product: what it is, what it does, and what makes it stand out. Key features, core selling points, and target users all help sharpen your matches.',
    productUrlMustBeValidLink: 'Please enter a valid link',
    atLeastOneInputRequired: 'Please fill in at least one field',
    productUrlChangedPrompt:
      'URL changed. Refresh the description and benchmarks to match the new link?',
    productDescriptionChangedPrompt:
      "Your product description has changed. Refresh benchmark suggestions to match the updated info? Benchmarks you've added won't be removed.",
    refreshSuggestNotNow: 'Not now',
    refreshSuggestRefresh: 'Refresh',
    matchedFromPrefix: 'Matched from',
    productUrlOrDescriptionLabel: 'Brand or product URL / description',
    productUrlOrDescriptionPlaceholder:
      "Use your brand link to promote the whole brand, or a product link to promote a specific product — the more specific, the sharper your matches. Skip if brand/product details shouldn't be considered.",
    referenceCreatorProfileLinksLabel: 'Reference influencer links (Optional)',
    referenceCreatorProfileLinksPlaceholder:
      'Paste Instagram, TikTok, or YouTube profile links',
    referenceCreatorProfileLinksHelp:
      'Separate multiple links with commas or new lines.',
    benchmarkProductWebsitesLabel: 'Benchmark products (Optional)',
    benchmarkProductWebsitesPlaceholder: 'Paste product page URLs...',
    benchmarkProductWebsitesHelp:
      "We'll use these products to build your ideal influencer profile, and also find influencers who've already collaborated with them.",
    benchmarkRecommendedTitle: '✦ Recommended from benchmark products',
    benchmarkAddAll: 'Add all',
    idealCreatorDescriptionLabel: 'Describe your ideal influencers (Optional)',
    idealCreatorDescriptionPlaceholder:
      'Briefly describe the creators you want — niche, audience, region, content style...',
    benchmarkTagsMustBeValidLink:
      'Each tag must contain a valid link. The following tags are invalid: {invalidTags}',
  },

  // V4 创建活动 — 画像卡片（Select Profiles 列表项）
  v4ProfilesCard: {
    discard: 'Discard',
    addToProfiles: 'Add',
    removeProfile: 'Discard',
    confirmToAdd: 'Confirm to add',
    profileNameLabel: 'Influencer profile name',
    profileNamePlaceholder: 'E.g: AI Tool reviewers, fashion blogger',
    descriptionLabel: 'Description',
    descriptionPlaceholder: 'Describe the influencer profile in detail',
  },

  // V4 创建活动 — 选择画像（Select Profiles）
  v4SelectProfiles: {
    title: 'Pick the influencer profiles that fit your campaign',
    subtitle:
      "We've generated some options based on your input. Add the ones you like",
    yourInputsTitle: 'Your inputs',
    yourInputsSubtitle: 'Edit any field to refine the generated profiles.',
    selectProfilesTitle: 'Select profiles',
    selectProfilesSubtitle:
      'AhaCreator will match influencers based on the selected influencer profiles',
    generatedProfilesTitle: 'Generated profiles',
    generatedProfilesSubtitle: 'Add the ones that fit your campaign.',
    addAll: 'Add all',
    clear: 'Clear',
    clearSelectedProfilesTitle: 'Clear selected profiles',
    clearSelectedProfilesDescription:
      'Are you sure you want to clear all selected profiles?',
    clearAll: 'Clear All',
    closeClearDialog: 'Close clear selected profiles dialog',
    addProfilesTitle: 'Add profiles',
    addProfilesExtractMode: 'Extract from text',
    addProfilesManualMode: 'Enter manually',
    addProfilesSourceText: 'Source text',
    addProfilesExtractedProfiles: 'Extracted profiles',
    addProfilesGenerate: 'Extract',
    addProfilesGenerating: 'Generating...',
    addProfilesSourcePlaceholder:
      'Paste text to extract influencer profiles',
    addProfilesEmptyExtracted:
      'Paste text on the left, then click “Extract.”',
    addProfilesProfileName: 'Profile name {index}',
    addProfilesAdd: 'Add',
    addProfilesAddToSelected: 'Add to selected profiles',
    removeAddedProfile: 'Remove added profile',
    closeAddProfilesDialog: 'Close add profiles dialog',
    addInfluencerProfiles: 'Add influencer profiles',
    needMoreProfiles: 'Need more profiles?',
    manuallyAdd: 'Add manually',
    allProfilesReviewed: 'You have completed the review of all the profiles.',
    matchingLoadingTitle:
      'Matching influencer profiles based on your inputs. Hang tight. This usually takes about 2 minutes.',
    selectedProfilesTitle: 'Selected profiles',
    selectedProfilesSubtitle: 'AhaCreator will match influencers to these',
    emptySelectedHint:
      'Select profiles from the generated list. AhaCreator will use them to find matching influencers.',
    unableToMatchTitle: 'Unable to match samples',
    unableToMatchDescription:
      'Choose an influencer profile or add a new one to continue.',
    startMatchingSamples: 'Start matching samples',
    profilesGeneratedFlash: 'Profiles generated',
    /** Fine-tune strategy — compact card + full-screen edit modal */
    fineTuneSectionTitle: 'Influencer Profiles',
    aiGeneratedBadge: 'AI generated',
    fineTuneEditModalSubtitle:
      'Describe your ideal influencers in natural language. You can also generate profiles from product info, reference influencers, or benchmark products below.',
    goToEditProfiles: 'Go to Edit Profiles',
  },

  // V4 创建活动 — Select Profiles 左侧表单区（ProfilesMain）
  v4ProfilesMain: {
    describeCreatorTitle: 'Describe your creator',
    describeCreatorSubtitle: 'The more detail, the better the match.',
    regenerateModalTitle: 'Keep the current generated profiles?',
    regenerateModalContent:
      "We'll generate new profiles based on your updated inputs. Do you want to keep the ones already shown below?",
    regenerateModalOk: 'Keep',
    regenerateModalCancel: "Don't keep",
  },

  v4BriefInfluencerBriefHighlight: {
    title: 'Brief highlight',
    optionalTitle: 'Brief highlight (optional)',
    placeholder: 'Type your brief highlight here',
    description:
      'Your full brief can be long. List must-know points here. Influencers will see these highlights first, so nothing critical gets missed.',
  },
};
